/**
 * informe-editor-validation.ts — pure validation logic for the InformeEditor wizard.
 *
 * validarPasoFn blocking gates:
 *   - AC paso 4 (Firmas): firmas.tecnico required.
 *   - IE/IS paso 2 (Panel fotográfico): no slot may hold a vertical photo.
 * All other step checks were removed per REQ-6 (S-6.1..S-6.6).
 *
 * // ponytail: pure function extracted from InformeEditor to make it testable
 * without mounting the component. No new abstraction — same logic, different home.
 */
import type { AcPayload, IePayload, IsPayload, TipoInforme } from "../types.js";

/** Wizard step index (0-based) of the Panel fotográfico for IE and IS. */
const PANEL_PASO = 2;

export interface ValidarPasoArgs {
  tipo: TipoInforme;
  ie: IePayload | null;
  is: IsPayload | null;
  ac: AcPayload | null;
  paso: number;
}

/**
 * Returns an error message string if the current step blocks advancing, or null
 * if it is safe to proceed.
 *
 * Only gate: AC paso 4 (Firmas) requires `firmas.tecnico` to be non-empty.
 */
export function validarPasoFn({ tipo, ie, is, ac, paso }: ValidarPasoArgs): string | null {
  if (tipo === "AC" && ac && paso === 4 && !ac.firmas.tecnico) {
    return "La firma del técnico es requerida.";
  }
  if (paso === PANEL_PASO) {
    const panel = tipo === "IE" ? ie?.panelFotografico : tipo === "IS" ? is?.panelFotografico : null;
    if (panel?.some((f) => f.vertical)) {
      return "Hay fotos verticales en el panel. Reemplázalas por fotos horizontales para continuar.";
    }
  }
  return null;
}
